import styled from "styled-components";

const NoResultsLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 64px;
  padding-top: 64px;
  width: 100%;

  font-size: 1.5rem;
  font-weight: 500;
  color: ${({ theme }): string => theme.colors.gray};
  text-align: center;
`;

interface NoResultsFoundMessageProps {
  message?: string;
}

export const NoResultsFoundMessage: React.FC<NoResultsFoundMessageProps> = ({
  message = "No results found",
}) => {
  return <NoResultsLabel>{message}</NoResultsLabel>;
};
